import React ,{createContext, useEffect,useState} from 'react'
import {getCources} from '../services/api';

export const CourcesContext=createContext();

const CourcesContextProvider=(props)=>{
    
    useEffect(()=>{
        const fetchApi=async ()=>{
            setCources(await getCources() );

        }
        fetchApi()
    },[])
    const [cources,setCources]=useState([]);
    return(
        <CourcesContext.Provider value={cources}>
            {props.children}
        </CourcesContext.Provider>
    )
}
export default CourcesContextProvider